/**
 * FAMILY_LABEL — etichette leggibili delle famiglie di relazione (chip di
 * filtro in `ChapterMap`, riga meta in `ConceptPanel`). Modulo condiviso per
 * evitare la duplicazione tra i due componenti (TASK-020 review).
 */
import type { MapLocale, RelationFamily } from '@arianna/reader-core'

export const FAMILY_LABEL: Record<MapLocale, Record<RelationFamily | 'all', string>> = {
  it: { all: 'Tutte', structure: 'Struttura', dynamic: 'Dinamica', contrast: 'Contrasto' },
  en: { all: 'All', structure: 'Structure', dynamic: 'Dynamic', contrast: 'Contrast' },
}
